<p class="application-p">Create first order using application ID</p>
<button (click)="openModal(template)" class="enter-application-btn">
      Enter Application ID
    </button>

<ng-template #template>
    <div class="modal-header header-appliacation-modal">
        <h4 class="modal-title text-center w-100">Create Order Through Application ID</h4>
        <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="modalRef?.hide()">
      <span aria-hidden="true" class="visually-hidden">&times;</span>
    </button>
    </div>
    <div class="modal-body application-modal">
        <form [formGroup]="applicationForm" class="application-form">
            <div class="form-group">
                <label>Enter Application ID <sup>*</sup></label>
                <input type="number" maxlength="8" formControlName="applicationId" name="applicationId" placeholder="e.g. 78965432" class="form-control" (keyup)="closeError()" required>
            </div>

            <div *ngIf="submitted && applicationForm.controls.applicationId?.errors" class="error">
                <div *ngIf="applicationForm.controls.applicationId.errors?.required"><img src="assets/images/error.svg">Please enter application Id</div>
            </div>
            <div *ngIf="showError" class="error">
                <div><img src="assets/images/error.svg">{{errorMsg}}</div>
            </div>
            <div class="after-clck">
                After clicking Submit, you will be redirected to the Cart.
            </div>
        </form>


        <div class="bottom-butoon">
            <button class="cancel-modal" (click)="closeModal()">Cancel</button>
            <button class="submit-modal" (click)="createApplicationOrder()">Submit</button>
        </div>
    </div>
</ng-template>
